import { HeroSection } from '../home/hero-section'
import { ServicesSection } from '../home/services-section'
import { TestimonialsSection } from '../home/testimonials-section'
import { SiteFooter } from '../layout/site-footer'
import { SiteHeader } from '../layout/site-header'
import { getHomeJsonLd } from '../../lib/seo'
import { PageTitle } from '../seo/page-title'

export interface HomepageProps {}

export function Homepage(_: Readonly<HomepageProps>) {
  const jsonLd = getHomeJsonLd()

  return (
    <div className="autoglow-home">
      <PageTitle title="Autoglow Detailing | Ceramic Coating & Paint Correction Bellarine & Geelong" />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <SiteHeader />
      <main id="main">
        <HeroSection />
        <ServicesSection />
        <TestimonialsSection />
      </main>
      <SiteFooter />
    </div>
  )
}

export default Homepage
